import {
  Typography,
  Button,
  Container,
  Box,
  Grid,
  useMediaQuery,
  Icon,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { NavLink, useHistory } from "react-router-dom";
import { HeroStyle } from "../Styles/LandingStyles";
import { MdArrowRight } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa";

const Hero = () => {
  const classes = HeroStyle();
  const theme = useTheme();
  const history = useHistory();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));

  const redirectToInfoPage = () => {
    history.push("/ido-step-by-step#refund-info");
  };

  return (
    <>
      <Box className={classes.hero} component="section">
        <Container fixed>
          <Grid container alignItems="center" spacing={0}>
            <Grid item md={6}>
              <Box data-aos="fade-up" data-aos-duration="1200" ml={0}>
                <Typography variant="h1" className="aspekta-semiBold">
                  Back projects <br />
                  you truly understand
                </Typography>
                <br />
                <Typography variant="body1" className="aspekta-regular white">
                  Support real projects,{" "}
                  <span
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => redirectToInfoPage()}
                  >
                    fully refundable
                  </span>{" "}
                  , led by expert teams, with measurable impact and clear
                  accountability.
                  <br /> <br />
                  <Box
                    className="aspekta-medium fs-14"
                    component="span"
                    style={{ color: "#4FFFEC" }}
                  >
                    Powered by GAINS
                  </Box>{" "}
                </Typography>
                <Grid
                  container
                  style={{ marginTop: isActive ? "5vh" : 0 }}
                  justifyContent="flex-start"
                >
                  <Grid
                    xs={12}
                    md={4}
                    item
                    style={{
                      padding: 0,
                    }}
                  >
                    <NavLink
                      style={{ marginTop: isActive ? ".5rem" : "3rem" }}
                      to="/deals"
                      className="text-decoration-none aspekta-regular white"
                    >
                      <Button
                        variant="contained"
                        className={classes.primaryButton}
                        style={{
                          minWidth: isActive ? "100%" : "10rem",
                        }}
                        size="large"
                        endIcon={<FaArrowRight size={12} />}
                      >
                        Upcoming Sales
                      </Button>
                    </NavLink>
                  </Grid>
                  <Grid
                    xs={12}
                    md={4}
                    item
                    style={{
                      padding: 0,
                    }}
                  >
                    <NavLink
                      to="/ido-step-by-step"
                      style={{ marginTop: isActive ? ".5rem" : "3rem" }}
                      className="text-decoration-none aspekta-regular white"
                    >
                      <Button
                        variant="outlined"
                        size="large"
                        style={{
                          minWidth: isActive ? "100%" : "10rem",
                          marginLeft: isActive ? 0 : "10px",
                        }}
                        className={classes.secondaryButton}
                      >
                        IDO Guide
                      </Button>
                    </NavLink>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Hero;
